$(function() {
  // console.log('page');

  // godzinowa prognoza pogody - slider
  if ($(".hourlyForecast li").length > 2 ) {
    const hourlySlider =  new Splide(".hourlyForecastSlider", {
      autoWidth: true,
      pagination: false, 
      arrows: false,
      perMove: 1,
      wheel: true,
      releaseWheel: 300,
      gap: "16px",
    })
    
    var bar = hourlySlider.root.querySelector( '.my-slider-progress-bar' );

    // Update the bar width:
    hourlySlider.on( 'mounted move', function () {
      var end = hourlySlider.Components.Controller.getEnd() + 1;
      bar.style.width = String( 100 * ( hourlySlider.index + 1 ) / end ) + '%';
    } );

    hourlySlider.mount();
  }

  //Wyswietl ukryte el / ukryj btn
  $("[data-show-el]").on('click', function (e) {
    showHiddenEl($(this));

    $(this).addClass("hideEl"); 
  });

  function showHiddenEl($obj) {
    $obj
      .closest("[data-hidden-el-wrapper]")
      .find("[data-hidden-el] li")
      .each(function () {
        if ($(this).hasClass("hideEl")) {
          $(this).removeClass("hideEl");
        }
      }); 
  }
});
